import { Component, Input } from '@angular/core';
import { ToolCapaciteService } from '../../../tool-capacite/tool-capacite.service';
@Component({
  selector: 'app-property-details-add-depenses',
  templateUrl: './property-details-add-depenses.component.html',
  styleUrls: ['./property-details-add-depenses.component.scss'],
  standalone: false
})
export class PropertyDetailsAddDepensesComponent {
  @Input() propertyId: string;

  @Input() hasDepenses: boolean;

  @Input() hasDettes: boolean;

  constructor(private readonly _toolCapaciteService: ToolCapaciteService) {}

  private modifierEtape(etape: string) {
    this._toolCapaciteService.modifierEtape(etape, 'propriete/detail/' + this.propertyId);
  }

  editDettes() {
    this.modifierEtape('dettes');
  }

  editDepenses() {
    this.modifierEtape('budget');
  }
}
